
import React from "react";

function TermsOfServices () {

    return <h3>TermsOfServices Under development</h3>
}

export default TermsOfServices;
